import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';

const ragStatusDescriptionHttpRequest = (() => {
  const apiName = 'ragStatusDescription';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `trial-management/rag-info/trial/:trialId`;
  return generatedHttpThunk.generateTrialThunk();
})();

export default ragStatusDescriptionHttpRequest;
